module.exports = __webpack_public_path__ + "img/about-1.3ee4fc23.jpg";